import { render, staticRenderFns } from "./CleanUpStatics.vue?vue&type=template&id=7cdceb58&scoped=true"
import script from "./CleanUpStatics.vue?vue&type=script&lang=ts"
export * from "./CleanUpStatics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdceb58",
  null
  
)

export default component.exports